import { render } from "./media_upload.vue?vue&type=template&id=f831fc74"
import script from "./media_upload.js?vue&type=script&lang=js"
export * from "./media_upload.js?vue&type=script&lang=js"

import "./media_upload.vue?vue&type=style&index=0&id=f831fc74&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__